module.exports = __webpack_public_path__ + "static/img/guoyao-logo2.8e1c690f.png";